// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"9c5d51cc","235":"a4074416","377":"02dc366f","700":"df3b7e58","876":"32c15945","970":"c948d29a"}[chunkId] + ".chunk.js";
};